import Vue from "vue"
import { Component, Prop, Emit } from "vue-property-decorator"
import { ValidationErrors } from "../../new-contract-vue";

@Component({
})

export default class ValidationMessage extends Vue {
    @Prop()
    public validationErrors: ValidationErrors;
    @Prop()
    public validationId: string;

    constructor() {
        super();
    }

    get message(): string {
        if (this.validationErrors != null && this.validationErrors.has(this.validationId))
            return this.validationErrors.get(this.validationId);
        return null;
    }
}